import CustomList from '../../../core/components/core/Util/List/CustomList/CustomList';
import CustomListContainer from '../../../core/components/core/Util/List/CustomList/CustomListContainer';
import config from '../../config/config';

function List() {

    const pathFrontEnd = '/gci/modality-types/';
    const endpointBackend = config.endpoints.backend;

    const paths = {
        pathAdd: pathFrontEnd + 'add',
        pathEdit: pathFrontEnd + 'edit',
        pathView: pathFrontEnd + 'view',
        endpointDelete: `${endpointBackend}gci/modality-types/delete`,
        endpoint: `${endpointBackend}gci/modality-types/getall`
    }

    let list = {
        labelTitle: 'Lista de Tipos de Modalidade',
        labelTitleButtonAdd: 'Incluir novo tipo de modalidade',
        fieldsShowOnDelete: ['modality_type'],
        columns: [
            {
                name: 'acronym',
                label: 'Sigla',
            },
            {
                name: 'modality_type',
                label: 'Tipo de Modalidade',
            }
        ]
    };

    list = { ...list, ...paths };

    return (
        <div>
            <CustomListContainer
                pathAdd={list.pathAdd}
                labelTitle={list.labelTitle}
                labelTitleButtonAdd={list.labelTitleButtonAdd}
                content={<CustomList list={{ ...list, ...paths }} />}
            />
        </div>
    );
}
export default List;
